export enum RestrictionTier {
  Blocked = "blocked",
  ActionNeeded = "action_needed",
  ComplianceInfo = "compliance_info",
  LaneNotice = "lane_notice",
}
